export enum POSITIONS {
  TOP = 'pos-a-c-t',
  CENTER = 'pos-a-c-m',
  BOTTOM = 'pos-a-c-b',
  RIGHT_TOP = 'pos-a-r-t',
  AUTO = 'pos-auto',
  DESKTOP_CENTER_MOBILE_TOP = 'pos-d-c-m-t',
  DESKTOP_TOP_MOBILE_BOTTOM = 'pos-d-t-m-b',
  DESKTOP_CENTER_MOBILE_BOTTOM = 'pos-d-c-m-b',
}
//econentWidth
export enum EOverlayContentWidth {
  DISABLED = 'overlay_content__disabled',
  AUTO = 'overlay_content__auto',
  AUTO_WITH_BOTTOM_NAV = 'overlay_content__auto-with-bottom-nav',
  SMALL = 'overlay_content__small',
  MEDIUM = 'overlay_content__medium',
  LARGE = 'overlay_content__large',
  REPLAY = 'overlay_content__replay_overlay',
  FILTER = 'overlay_content__filter_overlay',
  SPORT_BONUS = 'overlay_content__sport_bonus_overlay',
  BONUS_INFO_V2 = 'overlay_content__bonus_info_v2_overlay',
  FULL_SCREEN = 'overlay_content__full_screen',
  LOCKED_PROVIDER = 'overlay_content__locked_provider_overlay',
  MOB_CENTER_DESKTOP_CENTER = 'overlay_content__mob_center_desktop_center',
}
